import { render, staticRenderFns } from "./ChatMap.vue?vue&type=template&id=220c52ef&scoped=true"
import script from "./ChatMap.vue?vue&type=script&lang=js"
export * from "./ChatMap.vue?vue&type=script&lang=js"
import style0 from "./ChatMap.vue?vue&type=style&index=0&id=220c52ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220c52ef",
  null
  
)

export default component.exports